<template>
    <div>
        <price-filter
            v-if="filters.price"
            :filter-values="filterValues"
            :filters="filters"
            :label="$t('price')"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            :filters="filters"
            label="filters.insurance"
            filter="insuranceName"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            :filters="filters"
            label="filters.insurance"
            filter="insuranceDescription"
            @change="change($event)"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {filters} from '@/utils/insurance/insurance-blank-states'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import {FiltersBase} from '@/components/search/FiltersBase.vue'
    import CheckboxFilter from '@/components/search/filters/CheckboxFilter.vue'

    @Component({
        components: {
            CheckboxFilter,
            PriceFilter,
            NameFilter,
        },
    })
    export class InsuranceFilters extends FiltersBase {
        @Prop({required: true, default: () => filters()}) filterValues
    }

    export default InsuranceFilters
</script>
